import { render, staticRenderFns } from "./MeetingAssistant.vue?vue&type=template&id=0446ed46&scoped=true&"
import script from "./MeetingAssistant.vue?vue&type=script&lang=js&"
export * from "./MeetingAssistant.vue?vue&type=script&lang=js&"
import style0 from "./MeetingAssistant.vue?vue&type=style&index=0&id=0446ed46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446ed46",
  null
  
)

export default component.exports